import moment from 'moment';

// Everything outside production talks to test-mode Stripe, where a live-dashboard link makes a real id look missing
export const STRIPE_DASHBOARD =
  process.env.REACT_APP_NODE_ENV === 'production' ? 'https://dashboard.stripe.com' : 'https://dashboard.stripe.com/test';

export const COLLECTION_OPTIONS = [
  { value: 'auto_charge', label: 'Auto-charge', note: 'Charged the moment the invoice is issued.' },
  { value: 'send_invoice', label: 'Email invoice', note: 'They receive it and pay it themselves.' },
  { value: 'do_not_invoice', label: 'Don’t invoice', note: 'Nothing is generated. Handled by hand.' }
];

export const PAST_DUE_REMINDER_OPTIONS = [
  {
    value: false,
    label: 'Reminding in-app',
    note: 'Invoices past the past-due alert window open the blocking modal and lock features until they are paid.'
  },
  {
    value: true,
    label: 'Silenced in-app',
    note:
      'No modal, header notice, or menu count, and the past-due block on features lifts. Add Funds still locks past the overdue allowances. Stripe’s invoice emails are unaffected.'
  }
];

// Each row wears the qualities that decide how a brand gets billed, so the list reads without opening
// anyone. These state facts only — whether a brand should be switched depends on their IO, not on us.
// Nothing here claims a payment method still exists; only the detail page asks Stripe.
export const getBrandBillingQualities = brand => {
  const qualities = [
    brand.subscriptionInvoiced ? { label: 'subscription invoiced', tone: 'invoiced' } : { label: 'subscription auto-charges', tone: 'autocharge' }
  ];
  if (brand.subscriptionPinsPaymentMethod) qualities.push({ label: 'method pinned in Stripe', tone: 'card' });
  if (brand.commissionInvoiceCollection === 'do_not_invoice') qualities.push({ label: 'commissions by hand', tone: 'byhand' });
  else if (brand.commissionInvoiceCollection === 'auto_charge') qualities.push({ label: 'commissions auto-charge', tone: 'commissions' });
  if (brand.netPaymentTerms) qualities.push({ label: `net-${brand.netPaymentTerms}`, tone: 'terms' });
  return qualities;
};

export const formatMrr = mrr => (mrr ? `$${Math.round(mrr).toLocaleString()}` : '—');

export const formatPaymentMethod = method => {
  if (!method) return null;
  const last4 = method.card?.last4 || method.us_bank_account?.last4 || '••••';
  return `${method.type === 'us_bank_account' ? 'bank' : 'card'} ••${last4}`;
};

export const formatDollars = cents => (cents === null || cents === undefined ? '—' : `$${(cents / 100).toLocaleString(undefined, { maximumFractionDigits: 0 })}`); // prettier-ignore
export const formatStripeDate = seconds => (seconds ? moment.unix(seconds).format('MMM D, YYYY') : null);
export const formatBillingDate = value => (value ? moment(value).format('MMM D, YYYY') : null);
